import { MOCK_API } from "@/plugins/axios"
import moment from "moment"
type AlarmHistoricalData = {
  name?: string
  description?: string
  timestamp?: string
  state?: string
  detailedState?: string
  area?: string
}

export default class AlarmHistorical {
  name: string = ""
  description: string = ""
  timestamp: string = ""
  state: string = ""
  detailedState: string = ""
  area: string = ""

  constructor(data: AlarmHistoricalData) {
    Object.assign(this, data);
  }

  localeDate(locales?: string): string {
    return new Date(this.timestamp).toLocaleString(locales)
  }
}


interface QueryParams {
  name?: string,
  context?: string,
  start?: string, // iso format
  end?: string // iso format

  // JUST FOR MOCKED DATA
  quantity?: number
}

interface PaginationParams {
  page?: number
  pageSize?: number
}


export async function getAlarmsHistorical(params: QueryParams): Promise<AlarmHistorical[]> {
  try {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      // "Authorization": "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params };

    const res = await MOCK_API("alarms-historical/", config);

    if (res.status === 200 && res.data.alarms) {

    res.data.alarms.forEach( (e: any) => {
      if(e.alarms){
        e.alarms.map((e: any) =>{
          e.timestamp= moment(e.timestamp).format("DD-MM-YYYY HH:mm:ss")
          return e
        })
      }
      });
      return res.data.alarms
    }
    return []
  } catch (error) {
    console.error(error);
  }
  return [];
}




